import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../common/Modal';
import Icon, { GLYPHS } from '../../common/icon';
import KnowledgeArticleLink from '../../common/KnowledgeArticleLink';
import { ONE_TOUCH_PAYOUT_HELP_URL } from '../../common/KnowledgeArticleLink/constants';
import { t } from '../../../modules/infra/i18n';

const SuggestAutoPayoutModal = ({
  onGoToSetupHandler,
  onLearnMoreHandler,
  onPostponeHandler,
  onDeclineHandler,
  canGoToAutoPayoutSelfServe,
}) => (
  <Modal
    close={onDeclineHandler}
    className="c-suggest-auto-payout-modal c-suggest-auto-payout-modal__confetti c-modal-new"
    showCloseButton
  >
    <div
      className="o-flexbox o-flexbox--content-align-center o-flexbox--column u-p+"
      data-automation-id="auto-payout-suggestion-modal"
    >
      <Icon glyph={GLYPHS.capitalV2} size="large" className="c-modal-new__header-icon" />
      <div className="c-modal-new__header">
        {t('common:suggestion_modal.title')}
        {' '}
        <KnowledgeArticleLink
          url={ONE_TOUCH_PAYOUT_HELP_URL}
          tooltip={t('common:suggestion_modal.tooltip')}
        />
      </div>
      <p className="c-modal-new__text">
        {t('common:suggestion_modal.description')}
      </p>

      <button
        className="c-btn c-btn--medium u-mt+ u-width-100"
        onClick={onGoToSetupHandler}
        data-automation-id="auto-payout-suggestion-agree-button"
        display-if={canGoToAutoPayoutSelfServe}
      >
        {t('common:suggestion_modal.setup_now_button')}
      </button>
      <button
        className="c-btn c-btn--medium c-btn--ghost u-mt u-width-100"
        onClick={onLearnMoreHandler}
        data-automation-id="auto-payout-suggestion-learn-more-button"
      >
        {t('common:suggestion_modal.learn_more_button')}
      </button>
      <button
        className="c-btn c-btn--medium c-btn--blank u-mt u-width-100"
        onClick={onPostponeHandler}
        data-automation-id="auto-payout-suggestion-postpone-button"
      >
        {t('common:suggestion_modal.maybe_later_button')}
      </button>
    </div>
  </Modal>
);

SuggestAutoPayoutModal.propTypes = {
  onGoToSetupHandler: PropTypes.func.isRequired,
  onLearnMoreHandler: PropTypes.func.isRequired,
  onPostponeHandler: PropTypes.func.isRequired,
  onDeclineHandler: PropTypes.func.isRequired,
  canGoToAutoPayoutSelfServe: PropTypes.bool.isRequired,
};

export default SuggestAutoPayoutModal;
